import AppConfig from './app-config';
import Integrations from './integrations';
import Setup from './setup';
import View from './view';
import MailChimp from './mailchimp';
import NavigationStore from './navigation';
import BiLogger from './bi-logger';
import pubSub from '../pub-sub';
import EmbeddedIntegrations from './embedded-integrations';

let stores;
export const getStores = () => stores;

export default (config) => {
  const navigationStore = new NavigationStore({ config });
  stores = {
    navigation: navigationStore,
    embeddedIntegrations: new EmbeddedIntegrations({ config }),
    appConfig: new AppConfig({ config, pubSub }),
    integrations: new Integrations({ config, pubSub }),
    setup: new Setup({ config, pubSub }),
    view: new View({ config, pubSub, navigationStore }),
    mailchimp: new MailChimp(),
  };

  stores.biLogger = new BiLogger({ config, pubSub, stores });
  return stores;
};
